<template>
	<div>
		<notifications />
        <preloader v-if="isLoading"></preloader>
		<template-form
			title="Add Payment"
			submitTxt="Save Payment"
			:fields="fields"
			:errors="fieldErrors"
			:invoices="invoices"
			:isLoading="isLoading"
			:getInvoiceById="getInvoiceById"
			:onSubmit="handleSubmit" />
	</div>
</template>

<script>
import Form from './Form.vue';
import { defaultFields, defaultErrors } from "./helpers";
import { displayDate, incrementTailingNumber } from "../../helpers";
import Preloader from "../Preloader.vue";
import moment from 'moment';

export default {
	components: {
		'template-form': Form, Preloader
	},
	data() {
		return {
			isLoading: false,
			fields: defaultFields(),
			fieldErrors: defaultErrors(),
			invoices: [],
		}
	},
	async beforeMount() {
		this.isLoading = true;
		this.fields.invoice_id = '';
		try {
			let response = await axios.get('/invoices');
			this.invoices = response.data.data.map((value) => {return {...value, label: value.number + " " + value.title}});

			if (typeof this.$route.query.invoice_id !== "undefined") {
				const invoiceResponse = await axios.get(`/invoices/` + this.$route.query.invoice_id);
				this.fields = this.parseInvoice(invoiceResponse.data.data);
			}
			response = await axios.get('/receipts/last-number');
			this.fields.number = response.data.data ? 
				incrementTailingNumber(response.data.data) :
				this.fields.number;

			// debug
			console.log(this.fields)
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}


		this.isLoading = false;
	},
	methods: {
		async handleSubmit(fields) {
			this.fieldErrors = defaultErrors();
			this.isLoading = true;

			if (!this.validateInputs()) {
				this.isLoading = false;
				return;
			}

			try {
				const response = await axios.post('/receipts', {
					...fields,
					invoice_id: fields.invoice_id.id
				})
				
				this.$notify({
					type: 'success',
					title: 'Receipt added',
					text: 'You\'ve successfully saved payment receipt!'
				})

				this.$router.push(`/receipts/${response.data.data.id}/view`)

			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		parseInvoice(item) {
			return {
				invoice_id: {
					...item,
					label: item.number + " " + item.title
				},
				amount: item.grandtotal,
				date: moment().format('YYYY-MM-DD'),
			}
		},
		async getInvoiceById(id) {
			const invoiceResponse = await axios.get(`/invoices/` + id);
			const number = this.fields.number;
			this.fields = this.parseInvoice(invoiceResponse.data.data);
			this.fields.number = number;
		},
		validateInputs() {
			return true;
		},
	}
}
</script>
